import { getCollection, COLLECTIONS } from 'state/snapi/slice';

export const loadProgramMemberPhotos = params => dispatch =>
  dispatch(getCollection(COLLECTIONS.PROGRAM_MEMBER_PHOTOS, 'program_member_photos/search', params));
